/**
 * Analytics helper — centralizes all tracking calls.
 *
 * Meta (Facebook) Pixel is loaded via index.html.  The `fbq` global is only
 * available when a valid REACT_APP_FB_PIXEL_ID was set at build time.
 *
 * Every public function here is safe to call even when the pixel is absent —
 * the guard keeps it from throwing.
 */

const fbq = (...args) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq(...args);
  }
};

/* ------------------------------------------------------------------ */
/*  Standard events                                                    */
/* ------------------------------------------------------------------ */

/**
 * Fire after a successful waitlist signup.
 * Maps to Meta's standard "Lead" event so the ad set can optimise for it.
 *
 * @param {{ email?: string, utm_source?: string, utm_campaign?: string }} data
 */
export const trackLead = (data = {}) => {
  fbq("track", "Lead", {
    content_name: "waitlist_signup",
    ...data,
  });
};

/**
 * Fire when the waitlist modal is opened (measures intent).
 */
export const trackInitiateSignup = () => {
  fbq("track", "InitiateCheckout", {
    content_name: "waitlist_modal_open",
  });
};

/**
 * Fire on explicit page-view navigations inside the SPA (if routes are
 * added later).  The base PageView is already fired by the snippet in
 * index.html on initial load.
 */
export const trackPageView = () => {
  fbq("track", "PageView");
};

const analytics = { trackLead, trackInitiateSignup, trackPageView };
export default analytics;
